import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";

interface TestimonialCardProps {
  name: string;
  quote: string;
  rating: number;
}

export function TestimonialCard({ name, quote, rating }: TestimonialCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#d4a574]/30 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#d4a574]/5 to-transparent rounded-full -ml-16 -mt-16 group-hover:scale-150 transition-transform duration-700"></div>
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                className={`w-5 h-5 transition-all duration-300 ${
                  i < rating 
                    ? "fill-[#d4a574] text-[#d4a574] scale-100" 
                    : "text-gray-300 scale-90"
                }`}
              />
            ))}
          </div>
          <Quote className="w-8 h-8 text-[#d4a574]/20" />
        </div>

        <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d4a574] to-[#c89464] flex items-center justify-center text-white">
            {name.charAt(0)}
          </div>
          <div>
            <p className="text-[#2c2c2c]">{name}</p>
            <p className="text-[#999] text-sm">Verified Client</p>
          </div>
        </div>
        <br></br>
        <p className="text-[#666] leading-relaxed mb-6 min-h-[120px]">
          "{quote}"
        </p>
      </div>
    </motion.div>
  );
}
